import { render, staticRenderFns } from "./CarouselCategorias.vue?vue&type=template&id=1af620c7&scoped=true&"
import script from "./CarouselCategorias.vue?vue&type=script&lang=js&"
export * from "./CarouselCategorias.vue?vue&type=script&lang=js&"
import style0 from "./CarouselCategorias.vue?vue&type=style&index=0&id=1af620c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af620c7",
  null
  
)

export default component.exports